import styled from "styled-components"

export const DropzoneWrapper = styled.div`
  .styledDropzone {
    padding: 40px;
    background-image: linear-gradient(to right, #979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(to right, #979797 33%, rgba(255, 255, 255, 0) 0%),
      linear-gradient(#979797 33%, rgba(255, 255, 255, 0) 0%);
    background-position: bottom, right, top, left;
    background-size: 20px 1px, 1px 20px, 20px 1px, 1px 20px;
    background-repeat: repeat-x, repeat-y, repeat-x, repeat-y;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`

export const Img = styled.img`
  max-width: 82px;
  margin-right: 40px;
`
